import React, { useEffect } from 'react';
import { Toaster } from 'sonner';
import { useAuth } from './hooks/useAuth';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import LinkedInCallback from './pages/LinkedInCallback';
import FacebookCallback from './pages/FacebookCallback';
import PayInvoice from './pages/PayInvoice';
import QuoteSign from './pages/QuoteSign';
import ClientPortal from './pages/ClientPortal';
import ContractSign from './pages/ContractSign';

const App = () => {
  const { user, loading, logout } = useAuth();
  const { pathname } = window.location;

  // Redirection automatique pour un SaaS Pro
  useEffect(() => {
    // Si l'artisan est déjà connecté et tente d'aller sur /login ou /register
    if (user && (pathname === '/login' || pathname === '/register' || pathname === '/')) {
      window.history.replaceState({}, '', '/dashboard');
    }
  }, [user, pathname]);

  // Pages publiques — accessibles sans login
  if (pathname.startsWith('/pay/')) return <PayInvoice />;
  if (pathname.startsWith('/sign/')) return <QuoteSign />;
  if (pathname.startsWith('/portail/')) return <ClientPortal />;
  if (pathname.startsWith('/contract/')) return <ContractSign />;

  // OAuth Callbacks
  const urlParams = new URLSearchParams(window.location.search);
  const oauthCode = urlParams.get('code');
  if (oauthCode) {
    if (pathname === '/callback') return <LinkedInCallback code={oauthCode} />;
    if (pathname === '/facebook-callback') return <FacebookCallback code={oauthCode} platform="facebook" />;
    if (pathname === '/instagram-callback') return <FacebookCallback code={oauthCode} platform="instagram" />;
  }

  // Chargement initial de l'utilisateur
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f172a', color: 'white', fontSize: '1.2rem', fontFamily: 'Manrope,sans-serif' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
        <div style={{ width: '40px', height: '40px', border: '3px solid rgba(255,255,255,0.1)', borderTopColor: '#3b82f6', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
        <span>AKO Digital — Votre espace se prépare…</span>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  // Non connecté → page Login
  // Si on est sur le Dashboard mais non connecté, on force le login
  if (!user && (pathname.startsWith('/dashboard') || pathname === '/login' || pathname === '/register')) {
    return <Login onLoginSuccess={() => window.location.href = '/dashboard'} />;
  }

  // Connecté → Dashboard
  // On ne retourne le Dashboard QUE si on est sur la route /dashboard ou si on vient de se connecter
  if (user) {
    return (
      <>
        <Toaster
          position="bottom-right"
          theme="dark"
          richColors
          closeButton
          toastOptions={{ duration: 4000 }}
        />
        <Dashboard user={user} onLogout={logout} />
      </>
    );
  }

  // Par défaut (visiteur non connecté sur /) -> la landing page s'affiche via le service ako-landing
  return null;
};

export default App;
